import React from 'react'
import { connect } from 'react-redux'
import cn from 'classnames'
import { pathOr } from 'ramda'
import PropTypes from 'prop-types'

import { hideBodyScroll, showBodyScroll } from '../search/utils'
import { closePopup } from '../PopupConstructor/actions/popupActions'
import './popUp.scss'

/**
 * <PopUp>
 *   Write your html here.
 * </PopUp>
*/

class PopUp extends React.PureComponent {
  static defaultProps = {
    onCloseFunc: () => null,
    theme: 'default',
  }

  static propTypes = {
    onClose: PropTypes.func.isRequired,
    onCloseFunc: PropTypes.func,
    children: PropTypes.node.isRequired,
    popup: PropTypes.objectOf(Object).isRequired,
    theme: PropTypes.oneOf(['mobile-full', 'default']),
  }

  state = {
    scrollTop: null,
  }

  componentDidMount() {
    this.setState({ scrollTop: window.pageYOffset })
    hideBodyScroll()
  }

  componentWillUnmount() {
    showBodyScroll()
    const { scrollTop } = this.state

    if (scrollTop) {
      window.scrollTo(0, scrollTop)
    }
  }

  handleCloseClick = () => {
    const { onClose, popup, onCloseFunc } = this.props
    pathOr(() => {}, ['data', 'onBeforeClose'], popup)()
    onClose()
    onCloseFunc()
  }

  renderCloseBtn = (onClose, isMobile) => (
    <button
      type="button"
      className={cn('popup__close', isMobile)}
      onClick={onClose}
    >
      <span>
        Close
      </span>
    </button>
  )

  render() {
    const {
      children,
      theme
    } = this.props

    return (
      <div className={`popup popup-theme--${theme}`}>
        <div className="popup__content">
          {this.renderCloseBtn(this.handleCloseClick)}
          {children}
        </div>
        {this.renderCloseBtn(this.handleCloseClick, 'mobile')}
        <div
          tabIndex="0"
          role="button"
          onClick={this.handleCloseClick}
          onKeyDown={() => {}}
          className="popup__background-layer"
        />
      </div>
    )
  }
}

export default connect(({ popup }) => ({ popup }),
  dispatch => ({
    onClose: () => dispatch(closePopup()),
  }))(PopUp)
